module.exports = {
          srcSet: __webpack_public_path__ + "516f8601.jpg"+" 403w",
          images:[ {path: __webpack_public_path__ + "516f8601.jpg",width: 403,height: 244}],
          src: __webpack_public_path__ + "516f8601.jpg",
          toString:function(){return __webpack_public_path__ + "516f8601.jpg"},
          
          width: 403,
          height: 244
        }